import { useState } from 'react'
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3'
import { toast } from 'sonner'

import API from '@/lib/api'
import { useAuth } from '@/lib/auth'

import { Button } from '../ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Input } from '../ui/input'
import { Textarea } from '../ui/textarea'

export const FeedbackModal = ({
  isOpen,
  onToggle,
}: {
  isOpen: boolean
  onToggle: () => void
}) => {
  const { user } = useAuth({
    tmp: 'FeedbackModal',
  })
  const [message, setMessage] = useState('')
  const [email, setEmail] = useState(user?.email)
  const [recaptchaToken, setRecaptchaToken] = useState('')

  const onClickSend = () => {
    console.log('send')

    if (!recaptchaToken) {
      toast.error(
        'Pro odeslání zpětné vazby je potřeba ověřit, že jste člověk.',
        {
          description: 'Zkuste to prosím znovu.',
          duration: 5000,
          dismissible: true,
        },
      )

      return
    }

    API.post('/api/v2/feedback', {
      message,
      email,
      userId: user?.id,
      telemetry: {
        userAgent: navigator.userAgent,
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        screenColorDepth: screen.colorDepth,
        screenPixelRatio: window.devicePixelRatio,
        screenResolution: `${screen.width}x${screen.height}`,
        screenOrientation: screen.orientation,
        screenLanguage: navigator.language,
        screenColorScheme: window.matchMedia('(prefers-color-scheme: dark)')
          .matches
          ? 'dark'
          : 'light',
        url: window.location.href,
        referrer: document.referrer,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        origin: window.location.origin,
        protocol: window.location.protocol,
      },
      token: recaptchaToken,
    })
      .then(() => {
        toast.success('Vaše zpětná vazba byla úspěšně odeslána. Děkujeme!', {
          duration: 5000,
          dismissible: true,
        })

        onToggle()
      })
      .catch((err) => {
        console.error(err)

        if (
          err.response.status === 400 &&
          err.response.data.type === 'invalid-captcha'
        ) {
          toast.error('Nepodařilo se ověřit captchu.', {
            description: 'Zkuste to prosím znovu.',
            duration: 5000,
            dismissible: true,
          })
        } else {
          toast.error('Nastala chyba při odesílání zpětné vazby.', {
            description: 'Tak ani tohle se nám nepovedlo 😟',
            duration: 5000,
            dismissible: true,
          })
        }
      })
  }

  return (
    <Dialog open={isOpen} onOpenChange={onToggle}>
      <DialogContent className="min-w-[90vw] md:min-w-[40vw]">
        <DialogHeader>
          <DialogTitle>Zpětná vazba</DialogTitle>
          <DialogDescription>
            Snažíme se, aby aplikace byla co nejlepší, proto budeme rádi, když
            nám nahlásíte případný problém nebo návrh na vylepšení.
          </DialogDescription>
        </DialogHeader>
        <DialogDescription className="flex flex-col gap-4">
          <GoogleReCaptchaProvider
            reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
          >
            {/* <RecaptchaWrapper action="feedback" onToken={setRecaptchaToken} /> */}
            <GoogleReCaptcha onVerify={setRecaptchaToken} action="feedback" />
            <Textarea
              className="h-40"
              placeholder="Zde napište svou zpětnou vazbu, návrh na vylepšení, nebo popište problém, na který jste narazili."
              onChange={(e) => {
                setMessage(e.target.value)
              }}
            />

            {!user?.email && (
              <Input
                type="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                }}
              />
            )}

            <Button onClick={onClickSend}>Odeslat</Button>
          </GoogleReCaptchaProvider>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  )
}
